import {CustomPreviewProps, KILN_PART_PREVIEW_Y, KilnLayout} from '@domain/kiln-monitoring'
import {Stack} from '@mui/material'
import {useRef} from 'react'

import {DrivePart, KilnShellPart, StationPart} from './kiln-parts'
import './kilnPlaceholder.css'

interface StaticKilnSvgWrapperProps {
  kilnLayout: KilnLayout
  containerWidth?: number
  kilnLength: number
  onSvgClick?: () => void
  customSvgPreviews?: {
    drive?: (props: CustomPreviewProps) => React.ReactNode
    station?: (props: CustomPreviewProps) => React.ReactNode
    kilnShell?: (props: CustomPreviewProps) => React.ReactNode
  }
}

export const StaticKilnSvgWrapper = ({
  kilnLayout,
  customSvgPreviews,
  containerWidth,
  kilnLength,
  onSvgClick
}: StaticKilnSvgWrapperProps) => {
  const svgRef = useRef<null | SVGElement>(null)

  const kilnWidthInPx = kilnLayout.referenceDimensions.width
  const widthScaleFactor = containerWidth ? containerWidth / kilnWidthInPx : 1
  const meterToPixel = (kilnWidthInPx / kilnLength) * widthScaleFactor
  const stationPreviewY = kilnLayout.stations[0]?.y ?? 0
  const drivePreviewY = stationPreviewY + KILN_PART_PREVIEW_Y - kilnLayout.drive.y

  return (
    <Stack alignItems="flex-start" sx={{maxHeight: '100%'}}>
      <svg
        ref={svgRef as React.LegacyRef<SVGSVGElement> | undefined}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        height="250px"
        width="100%"
        onClick={onSvgClick}
        style={{
          maxHeight: '300px'
        }}
      >
        <KilnShellPart
          {...kilnLayout.kilnShell}
          widthScaleFactor={widthScaleFactor}
          customSvgPreview={customSvgPreviews?.kilnShell}
          meterToPixel={meterToPixel}
          kilnLength={kilnLength}
        />

        {kilnLayout.stations.map((station) => (
          <StationPart
            key={station.id}
            {...station}
            customSvgPreview={customSvgPreviews?.station}
            widthScaleFactor={widthScaleFactor}
            meterToPixel={meterToPixel}
          />
        ))}
        <DrivePart
          {...kilnLayout.drive}
          // the default "side" is left
          flip={
            kilnLayout.drive.side === 'right' ||
            (!kilnLayout.drive.side && kilnLayout.materialFlow !== 'rightToLeft') // this is for backwards compatibility
          }
          customSvgPreview={customSvgPreviews?.drive}
          previewY={drivePreviewY}
          widthScaleFactor={widthScaleFactor}
          meterToPixel={meterToPixel}
        />
      </svg>
    </Stack>
  )
}
